/** @jsx jsx */
import { Box, Container, Grid, Heading, jsx } from 'theme-ui'
import ListingCardSpecs from '~/components/Listing/Card/Specs'

const FeaturedWinesSection = ({
  title,
  description,
  cta,
  isNarrow,
  media,
  bgOverride,
  collapseMarginTop,
}) => {
  return (
    <Box
      bg={bgOverride || 'backgroundDark'}
      pt={!collapseMarginTop && [7, 9, null, 13]}
      pb={[8, 10, null, 14]}
    >
      <Container>
        {title && (
          <Grid mb={[6, 7, null, 9]} columns={[null, 12]}>
            <Box sx={{ gridColumn: [null, '2 / 12', null, '3 / 11'] }}>
              <Heading
                as="h2"
                variant="title2"
                mb={2}
                sx={{ textAlign: 'center' }}
              >
                {title}
              </Heading>
              {description && (
                <Box
                  variant="text.body1"
                  dangerouslySetInnerHTML={{
                    __html: description.childMarkdownRemark.html,
                  }}
                  sx={{
                    textAlign: 'center',
                    p: {
                      m: 0,
                    },
                  }}
                />
              )}
            </Box>
          </Grid>
        )}
        <Grid columns={[1, 12, isNarrow ? 3 : 2]}>
          {media.map((node, index) => {
            const { kits, mainImage, name, product, slug, subtitle, tags } =
              node

            const { kitDescription, sellSheetDescription } =
              kits?.[0]?.products?.[0] || product

            return (
              <Box
                key={`featured-wine-${slug}-index`}
                sx={{ gridColumn: [null, '2 / 12', 'auto'] }}
              >
                <ListingCardSpecs
                  description={isNarrow ? sellSheetDescription : kitDescription}
                  image={mainImage}
                  isNarrow={isNarrow}
                  subtitle={subtitle}
                  subtitleVariant={isNarrow && 'body3'}
                  tags={!isNarrow && tags}
                  title={name}
                  titleVariant={isNarrow && 'title4'}
                />
              </Box>
            )
          })}
        </Grid>
        {cta && (
          <Box mt={[5, 7]} sx={{ textAlign: 'center' }}>
            {cta}
          </Box>
        )}
      </Container>
    </Box>
  )
}

export default FeaturedWinesSection
